import { project2BaseUrl } from "./remoteClient";

export async function requestData(token, compId){
        return await project2BaseUrl.get(
            `competencyReport/getData?compId=${compId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
}

export async function requestAllData(token){
        return await project2BaseUrl.get(
            `competencyReport/getAllData`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
}